module.exports = __webpack_public_path__ + "static/flags/BP-842556707f01691b446829ba620cfa56.gif";